// Generated by scripts/syncNotificationMessages.py — do not edit.
//
// Every variable the notification texts may ask about. ICU throws on a
// missing argument instead of taking the "none" branch, so the renderer
// passes all of them, absent ones included.
export const NOTIFICATION_VARIABLES = [
  'activity_type',
  'admin_comment',
  'ap_amount',
  'available_at',
  'brand_name',
  'club_name',
  'code',
  'device_info',
  'donated_amount',
  'level_name',
  'news_title',
  'platform',
  'pts_earned',
  'reason',
  'referral_username',
  'source_type',
  'step_title',
  'task_type',
  'username'
] as const
